<template>
  <div>
    <!-- 表格 -->
    <lin-table
      ref="table"
      :tableColumn="tableColumn"
      :tableData="tableData"
      :operate="operate"
      @handleDelete="handleDelete"
      v-loading="loading"></lin-table>    
  </div>
</template>

<script>
import LinTable from '@/components/base/table/lin-table'
import projectSalesmanApi from '../../models/project_salesman'
import ChangeStatusItem from './ChangeStatusItem'

export default {
  components: {
    LinTable,
  },
  data() {
    return {
      tableColumn: [
        { prop: 'project.title', label: '项目名' },
        { prop: 'role', label: '角色' , component: ChangeStatusItem,},
      ],
      tableData: [],
      operate: [],
      viewStatus: 1,
      dataID: 1,

      selectedRow: {},
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = [
      {
        name: '删除',
        func: 'handleDelete',
        type: 'danger',
        auth: '删除项目',
      }]
    this.loading = false
  },
  methods: {
    async getDatas() {
      try {
        this.loading = true
        const data = await projectSalesmanApi.gets({ count: this.pageCount, page: this.currentPage, q: this.searchKeyword, salesman_id: this.dataID })
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    handleDelete(val) {
      this.$confirm('此操作将与该项目解除绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await projectSalesmanApi.delete(val.row.id)
        if (res.error_code === 0) {
          await this.getDatas()
          this.$message({
            type: 'success',
            message: `${res.msg}`,
          })
        }
      })
    },
    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}
</style>
